<template>
  <section class="footer">
    <div class="footer-image__container">
      <!--<a href="https://www.canada.ca">-->
        <img class="footer-logo" :src="require('@/assets/images/partners/ccncto.png')" />
      <!--</a>-->
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer"
};
</script>
<style>
.footer {
  display: flex;
  justify-content: flex-end;
  height: auto;
  background: lightgrey;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}

.footer-image__container {
  width: 400px;
}

.footer-logo {
  width: auto;
  max-height: 150px;
}

@media only screen and (max-width: 800px) {
  .footer {
    display: flex;
    justify-content: center;
  }
}
</style>